// Workspace app envs. Resolves the workspace wrapper URL by environment.
//
// Single source of truth for the wrapper base lives at
// `shared/functions/workspaceApiBase.js` — every consumer (SDK init,
// Supabase passthrough, this file) calls through it so a single override
// flips every endpoint at once.
import { apiUrl as channelApiUrl } from '@symbo.ls/channels'
import { workspaceApiBase } from '../shared/functions/workspaceApiBase.js'

const RESOLVE_API_URL = () => workspaceApiBase()

export default {
  workspaceApiUrl: RESOLVE_API_URL(),
  symbolsApiUrl: channelApiUrl()
}
